import { Tag } from "@app/types/Cue";
import brandedPodcastThumbnail from "@assets/podcasts_banner/masthead-branded-podcasts.png";
import lensOnThumbnail from "@assets/podcasts_banner/masthead-lens-on.png";
import markToMarketThumbnail from "@assets/podcasts_banner/masthead-mark-to-market.png";
import marketFocusThumbnail from "@assets/podcasts_banner/masthead-market-focus.png";
import moneyHacksThumbnail from "@assets/podcasts_banner/masthead-money-hacks.png";
import propertyBTThumbnail from "@assets/podcasts_banner/masthead-propertybt.png";
import wealthBTThumbnail from "@assets/podcasts_banner/masthead-wealthbt.png";

export type PodcastKeywordData = {
  name:
    | "marketFocus"
    | "moneyHacks"
    | "lensOn"
    | "wealthBT"
    | "propertyBT"
    | "markToMarket"
    | "brandedPodcasts";
  label: string;
  spotify_link: string;
  apple_link: string;
  channel_link: string;
  google_link: string;
  tag: Tag;
  description: string;
  thumbnailSrc: string;
};

export const PODCAST_KEYWORDS_DATA: PodcastKeywordData[] = [
  {
    name: "marketFocus",
    label: "Market Focus",
    spotify_link: "https://bt.sg/mfsp",
    apple_link: "https://bt.sg/mfap",
    channel_link: "https://bt.sg/btmktfocus",
    google_link: "https://bt.sg/mfgo",
    tag: { name: "Market Focus", uri: "main/market-focus" },
    description:
      "Market Focus is a weekly podcast by The Business Times that looks at the market drivers and movements in Singapore, the region and the globe.",
    thumbnailSrc: marketFocusThumbnail,
  },
  {
    name: "moneyHacks",
    label: "Money Hacks",
    spotify_link: "https://bt.sg/oeGN",
    apple_link: "https://bt.sg/oeXe",
    channel_link: "https://bt.sg/btmoneyhacks",
    google_link: "https://bt.sg/oeGP",
    tag: { name: "Money Hacks", uri: "main/money-hacks" },
    description:
      "In this series, The Business Times breaks down actionable financial tips.",
    thumbnailSrc: moneyHacksThumbnail,
  },
  {
    name: "lensOn",
    label: "Lens On",
    spotify_link: "https://bt.sg/lenssp",
    apple_link: "https://bt.sg/lensap",
    channel_link: "https://bt.sg/btlenson",
    google_link: "https://bt.sg/lensgo",
    tag: { name: "Lens On", uri: "main/lens-on" },
    description:
      "A monthly podcast series from The Business Times on current affairs, societal issues and government policies explored through the lens of how it impacts us in Singapore and the region.",
    thumbnailSrc: lensOnThumbnail,
  },
  {
    name: "wealthBT",
    label: "WealthBT",
    spotify_link: "http://bt.sg/wbSP",
    apple_link: "https://bt.sg/4DJp",
    channel_link: "https://bt.sg/",
    google_link: "https://bt.sg/",
    tag: { name: "WealthBT", uri: "main/wealthbt" },
    description:
      "Learn to protect and grow your wealth in our monthly podcast series for affluent individuals, hosted by BT wealth editor Genevieve Cua.",
    thumbnailSrc: wealthBTThumbnail,
  },
  {
    name: "propertyBT",
    label: "PropertyBT",
    spotify_link: "https://bt.sg/pbSP",
    apple_link: "https://bt.sg/pbAP",
    channel_link: "https://bt.sg/btwealthbt",
    google_link: "https://bt.sg/wtGO",
    tag: { name: "PropertyBT", uri: "main/propertybt" },
    description:
      "Get insights from The Business Times on all things Singapore property, to help you in your property investment journey from senior correspondent Leslie Yee and industry players.",
    thumbnailSrc: propertyBTThumbnail,
  },
  {
    name: "markToMarket",
    label: "Mark to Market",
    spotify_link: "https://bt.sg/4DJN",
    apple_link: "https://bt.sg/4DJp",
    channel_link: "https://bt.sg/btmark2mkt",
    google_link: "https://bt.sg/4D2E",
    tag: { name: "Mark to Market", uri: "main/mark-to-market" },
    description:
      "In this series, The Business Times aims to provide analysis and insight on market trends and corporate issues in Singapore.",
    thumbnailSrc: markToMarketThumbnail,
  },
  {
    name: "brandedPodcasts",
    label: "Branded Podcasts",
    spotify_link: "https://bt.sg/bpsp",
    apple_link: "https://bt.sg/bpap",
    channel_link: "https://bt.sg/btbrpod",
    google_link: "https://bt.sg/bpgo",
    tag: { name: "Branded Podcasts", uri: "main/branded-podcasts" },
    description:
      "Finely curated, intelligent, thought-provoking branded content for decision-makers. Inspired by the newsroom of your trusted partner.",
    thumbnailSrc: brandedPodcastThumbnail,
  },
];
